<script setup lang="ts">

const props = defineProps({
    text: String,
})

</script>

<template>
    <h3 class="page-title">{{ text }}</h3>
</template>

<style scoped>

    @media only screen and (max-width: 629px) {
        .page-title {
            margin-top: 1rem;
            margin-bottom: 1rem;
        }
    }

</style>
